import { AuthenticationComponent } from './components/authentication/authentication.component'
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';


export const AuthenticationRoutes: Routes = [
  { path: 'login/app-authentication', redirectTo: 'app-login' },
  { path: 'login/app-authentication', component: LoginComponent }
];